// Enable only after configuring this store's own server-side payment credentials.
export const PAYMENTS_ENABLED = false;
